export default "__VITE_ASSET__fc0170c9__"